import * as xhr from 'xhr';
import * as buildQuery from 'http-build-query';
import showNotification from '../utils/showNotification';

export const API_PATH =
    process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_BASE_PATH || '/api/v1/' : 'http://localhost:3009/';

/**
 * отправлет запрос к API и возвращает Promise с результатом.
 *
 * @param   string  url     Путь до REST метода, отновительно API_PATH
 * @param   object  params  Параметры запроса
 * @param   string  method  HTTP метод запроса.
 *
 * @return  Promise
 */
export function fetch(url, params, method) {
    return new Promise((resolve, reject) => {
        let options = {
            url: API_PATH + url,
            method: method || 'GET',
            headers: {
                'Access-Token': getToken(),
            },
        };

        if (localStorage.csrf_token) options.headers['X-CSRF-Token'] = localStorage.csrf_token;

        if (!isSafeMethod(method || 'GET')) {
            if (process.env.NODE_ENV === 'production') {
                options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                options.body = buildQuery(params);
            } else {
                options.headers['Content-Type'] = 'application/json';
                options.body = JSON.stringify(params);
            }
        } else {
            options.url = API_PATH + url + '?' + buildQuery(params);
        }

        xhr(options, (err, res) => {
            if (res.headers['x-csrf-token']) localStorage.csrf_token = res.headers['x-csrf-token'];

            if (res.statusCode === 500 && !res.body?.success) {
                const error = JSON.parse(res.body).error;

                if (error === 'RETRY_LATER') {
                    showNotification('danger', 'Не удалось получить данные из сервера. Повторите попытку еще раз.', null, 5000);
                } else {
                    showNotification('danger', error, null, 5000);
                }
            }

            if (res.body == null) console.log('protocol_error');

            if (JSON.parse(res.body).error) {
                if (JSON.parse(res.body).error === 'USER_NOT_AUTH') {
                    setUserID(0);
                    window.location.href = `/${process.env.REACT_APP_ROUTE_BASE}/login/`;
                } else {
                    reject(JSON.parse(res.body));
                }
            } else resolve(JSON.parse(res.body));
        });
    });
}

const TOKEN = 'Token';

function isSafeMethod(httpMethod) {
    return ['GET', 'HEAD', 'OPTIONS'].indexOf(httpMethod) !== -1;
}

// export function getUserID() {
//     return localStorage.userID;
// }

export function isAuth() {
    return localStorage.userID != null && localStorage.userID > 0;
}

export function setUserID(id) {
    localStorage.userID = id;
}

export const setToken = token => localStorage.setItem(TOKEN, token);

export const getToken = () => localStorage.getItem(TOKEN);

export const deleteToken = () => localStorage.removeItem(TOKEN);
